import * as React from "react";
import {useState, useContext, createContext} from 'react';

const DashboardContext = createContext({categories:null, setCategories: null});

export const DashboardProvider = ({children}) => {
  const [categories, setCategories] = useState([]);
  return (
    <DashboardContext.Provider value={{categories:categories, setCategories: setCategories}}>
      {children}
    </DashboardContext.Provider>
  )
};

export default function useDashboard() {
  return useContext(DashboardContext);
}


// WEBPACK FOOTER //
// ./app/javascript/hooks/useDashboard.tsx